"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listAndBlockButtons = exports.headingButtons = exports.formattingButtons = exports.alignmentButtons = void 0;
var _CodeRounded = _interopRequireDefault(require("@mui/icons-material/esm/CodeRounded.js"));
var _FormatAlignCenterRounded = _interopRequireDefault(require("@mui/icons-material/esm/FormatAlignCenterRounded.js"));
var _FormatAlignJustifyRounded = _interopRequireDefault(require("@mui/icons-material/esm/FormatAlignJustifyRounded.js"));
var _FormatAlignLeftRounded = _interopRequireDefault(require("@mui/icons-material/esm/FormatAlignLeftRounded.js"));
var _FormatAlignRightRounded = _interopRequireDefault(require("@mui/icons-material/esm/FormatAlignRightRounded.js"));
var _FormatBoldRounded = _interopRequireDefault(require("@mui/icons-material/esm/FormatBoldRounded.js"));
var _FormatItalicRounded = _interopRequireDefault(require("@mui/icons-material/esm/FormatItalicRounded.js"));
var _FormatListBulleted = _interopRequireDefault(require("@mui/icons-material/esm/FormatListBulleted.js"));
var _FormatListNumbered = _interopRequireDefault(require("@mui/icons-material/esm/FormatListNumbered.js"));
var _FormatQuote = _interopRequireDefault(require("@mui/icons-material/esm/FormatQuote.js"));
var _FormatSizeSharp = _interopRequireDefault(require("@mui/icons-material/esm/FormatSizeSharp.js"));
var _FormatUnderlinedRounded = _interopRequireDefault(require("@mui/icons-material/esm/FormatUnderlinedRounded.js"));
var _HighlightRounded = _interopRequireDefault(require("@mui/icons-material/esm/HighlightRounded.js"));
var _Link = _interopRequireDefault(require("@mui/icons-material/esm/Link.js"));
var _StraightenRounded = _interopRequireDefault(require("@mui/icons-material/esm/StraightenRounded.js"));
var _StrikethroughSRounded = _interopRequireDefault(require("@mui/icons-material/esm/StrikethroughSRounded.js"));
var _TerminalSharp = _interopRequireDefault(require("@mui/icons-material/esm/TerminalSharp.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const headingButtons = exports.headingButtons = [{
  value: 'Normal',
  ariaLabel: 'Normal',
  tooltip: 'Normal',
  command: 'setParagraph',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatSizeSharp.default, {})
}, {
  value: 'heading1',
  ariaLabel: 'heading level 1',
  tooltip: 'Large Heading',
  command: 'toggleHeading',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
    fontWeight: "bold",
    children: "H1"
  }),
  options: {
    level: 1
  }
}, {
  value: 'heading2',
  ariaLabel: 'heading level 2',
  tooltip: 'Medium Heading',
  command: 'toggleHeading',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
    fontWeight: "bold",
    children: "H2"
  }),
  options: {
    level: 2
  }
}, {
  value: 'heading3',
  ariaLabel: 'heading level 3',
  tooltip: 'Small Heading ',
  command: 'toggleHeading',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
    fontWeight: "bold",
    children: "H3"
  }),
  options: {
    level: 3
  }
}];
const formattingButtons = exports.formattingButtons = [{
  value: 'bold',
  ariaLabel: 'bold',
  tooltip: 'Bold (Ctrl+B)',
  command: 'toggleBold',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatBoldRounded.default, {})
}, {
  value: 'italic',
  ariaLabel: 'italic',
  tooltip: 'Italic (Ctrl+I)',
  command: 'toggleItalic',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatItalicRounded.default, {})
}, {
  value: 'underline',
  ariaLabel: 'underline',
  tooltip: 'Underline (Ctrl+U)',
  command: 'toggleUnderline',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatUnderlinedRounded.default, {})
}, {
  value: 'strike',
  ariaLabel: 'strikethrough',
  tooltip: 'Strikethrough (Ctrl+Shift+S)',
  command: 'toggleStrike',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StrikethroughSRounded.default, {})
}, {
  value: 'code',
  ariaLabel: 'inline code',
  tooltip: 'Inline Code (Ctrl+Shift+C)',
  command: 'toggleCode',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CodeRounded.default, {})
}, {
  value: 'highlight',
  ariaLabel: 'highlight',
  tooltip: 'Highlight (Ctrl+Shift+H)',
  command: 'toggleHighlight',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_HighlightRounded.default, {})
}, {
  value: 'link',
  ariaLabel: 'link',
  tooltip: 'Link',
  command: 'toggleLink',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {})
}];
const listAndBlockButtons = exports.listAndBlockButtons = [{
  value: 'bullet list',
  ariaLabel: 'bullet list',
  tooltip: 'Bullet Point List (Ctrl + Shift + 8)',
  command: 'toggleBulletList',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatListBulleted.default, {})
}, {
  value: 'ordered list',
  ariaLabel: 'ordered list',
  tooltip: 'Ordered List (Ctrl + Shift + 7)',
  command: 'toggleOrderedList',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatListNumbered.default, {})
}, {
  value: 'divider',
  ariaLabel: 'divider',
  tooltip: 'Add Divider',
  command: 'setHorizontalRule',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StraightenRounded.default, {})
}, {
  value: 'code block',
  ariaLabel: 'code block',
  tooltip: 'Code block',
  command: 'toggleCodeBlock',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TerminalSharp.default, {})
}, {
  value: 'block quote',
  ariaLabel: 'block quote',
  tooltip: 'Block quote',
  command: 'toggleBlockquote',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatQuote.default, {})
}];
const alignmentButtons = exports.alignmentButtons = [{
  value: 'alignLeft',
  ariaLabel: 'align left',
  tooltip: 'Align Left (Ctrl + Shift + L)',
  command: 'setTextAlign',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatAlignLeftRounded.default, {})
}, {
  value: 'alignCenter',
  ariaLabel: 'align center',
  tooltip: 'Align Center (Ctrl + Shift + E)',
  command: 'setTextAlign',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatAlignCenterRounded.default, {})
}, {
  value: 'alignRight',
  ariaLabel: 'align right',
  tooltip: 'Align Right (Ctrl + Shift + R)',
  command: 'setTextAlign',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatAlignRightRounded.default, {})
}, {
  value: 'alignJustify',
  ariaLabel: 'justify',
  tooltip: 'Justify (Ctrl + Shift + J)',
  command: 'setTextAlign',
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormatAlignJustifyRounded.default, {})
}];